import { dispatchCartEvent } from "@nx-paeonia/feature-components";
import { progressInstance } from "@nx-paeonia/utils-events";
import { isOk } from "@nx-paeonia/utils-result";
import { addFormDataToCart } from "@nx-paeonia/utils-shopify";
import { html, LitElement } from "lit";

/**
 * TODO: Move this to own library/class
 */
class AddToCartComponent extends LitElement {
	override connectedCallback(): void {
		super.connectedCallback();
		this.addEventListener("click", this.onClick.bind(this));
	}
	override disconnectedCallback(): void {
		super.disconnectedCallback();
		this.removeEventListener("click", this.onClick.bind(this));
	}

	private async onClick(event: Event): Promise<void> {
		const parentForm = this.closest<HTMLFormElement>("form");
		progressInstance.start();

		if (parentForm) {
			event.preventDefault();

			const formData = new FormData(parentForm);
			formData.append("action", "add-to-cart");
			const result = await addFormDataToCart(formData);

			if (isOk(result)) {
				dispatchCartEvent("CART_FLYOUT_RERENDER");
				dispatchCartEvent("CART_BUTTON_UPDATE_COUNTER");
				dispatchCartEvent("CART_FLYOUT_SHOW");
			}
		}
		progressInstance.done();
	}

	override render() {
		return html`<slot></slot>`;
	}
}

if (!customElements.get("y-add-to-cart")) {
	customElements.define("y-add-to-cart", AddToCartComponent);
}
